import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { apiOpsV2 } from '@/lib/api/ops-v2'

export const OpsUserSchema = z.looseObject({
  id: z.string(),
  name: z.string().default(''),
  email: z.string().default(''),
  profilePicture: z.string().nullish(),
})

export type OpsUserDto = z.infer<typeof OpsUserSchema>

export type LoadOpsUsersParams = {
  search?: string
  limit?: number
}

export async function loadOpsUsers(params: LoadOpsUsersParams): Promise<OpsUserDto[]> {
  const res = await apiOpsV2.get('/users', { params })
  return z.array(OpsUserSchema).parse(res.data)
}

export const opsUsersKeys = {
  all: ['opsUsers'] as const,
  searches: () => [...opsUsersKeys.all, 'search'] as const,
  search: (params: LoadOpsUsersParams) => [...opsUsersKeys.searches(), params] as const,
}

export function opsUsersSearchOptions(params: LoadOpsUsersParams) {
  return queryOptions({
    queryKey: opsUsersKeys.search(params),
    queryFn: () => loadOpsUsers(params),
    staleTime: 30_000,
  })
}
